var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path8, _g9, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g10, _g11, _g12, _g13, _g14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#r89dl3y68a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.23 6.664a1.518 1.518 0 0 1 2.81-.757l2.856 4.629a1.637 1.637 0 0 1-1.824 2.44 1.64 1.64 0 0 1-1-.782l-.195-.35a1.698 1.698 0 0 1-1.93 1.325l.023.04c.248.43.274.927.114 1.358l5.06 7.241c-.586.352-2.15 1.02-4.354.446-2.032-.656-3.041-1.817-3.744-3.012L4.37 12.967a1.59 1.59 0 0 1 1.477-2.387l-.285-.512a1.556 1.556 0 0 1 1.636-2.29l-.058-.103a1.58 1.58 0 0 1 2.725-1.601l.365.59z",
    fill: "url(#vm5b2u7dcb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.23 6.664a1.518 1.518 0 0 1 2.81-.757l2.856 4.629a1.637 1.637 0 0 1-1.824 2.44 1.64 1.64 0 0 1-1-.782l-.195-.35a1.698 1.698 0 0 1-1.93 1.325l.023.04c.248.43.274.927.114 1.358l5.06 7.241c-.586.352-2.15 1.02-4.354.446-2.032-.656-3.041-1.817-3.744-3.012L4.37 12.967a1.59 1.59 0 0 1 1.477-2.387l-.285-.512a1.556 1.556 0 0 1 1.636-2.29l-.058-.103a1.58 1.58 0 0 1 2.725-1.601l.365.59z",
    fill: "url(#d36sg3992c)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.143 7.963a1.556 1.556 0 0 0-.58 2.105l.284.512c.51.035.996.315 1.27.791l2.446 4.235a1.598 1.598 0 0 0 1.407-2.397l-2.7-4.677a1.556 1.556 0 0 0-2.127-.57z",
    fill: "url(#ng29t901md)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.143 7.963a1.556 1.556 0 0 0-.58 2.105l.284.512c.51.035.996.315 1.27.791l2.446 4.235a1.598 1.598 0 0 0 1.407-2.397l-2.7-4.677a1.556 1.556 0 0 0-2.127-.57z",
    fill: "url(#muvpp4p9te)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 5.537a1.58 1.58 0 0 0-.59 2.137l.058.105a1.553 1.553 0 0 1 1.072.753l2.677 4.637a1.703 1.703 0 0 0 1.713-2.577L9.865 6.074a1.58 1.58 0 0 0-2.135-.537z",
    fill: "url(#rjyxqwqcuf)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 5.537a1.58 1.58 0 0 0-.59 2.137l.058.105a1.553 1.553 0 0 1 1.072.753l2.677 4.637a1.703 1.703 0 0 0 1.713-2.577L9.865 6.074a1.58 1.58 0 0 0-2.135-.537z",
    fill: "url(#6u7v62dtng)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.23 6.664 2.43 3.928c.232.374.31.823.217 1.253l.195.35a1.637 1.637 0 1 0 2.824-1.658l-2.856-4.63a1.519 1.519 0 0 0-2.81.758v-.001z",
    fill: "url(#m15e99bkyh)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10.23 6.664 2.43 3.928c.232.374.31.823.217 1.253l.195.35a1.637 1.637 0 1 0 2.824-1.658l-2.856-4.63a1.519 1.519 0 0 0-2.81.758v-.001z",
    fill: "url(#33xwknrbfi)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.096 11.325a1.584 1.584 0 1 0-2.697 1.663l4.073 6.608a1.584 1.584 0 1 0 2.697-1.662l-4.073-6.609z",
    fill: "url(#dufrd1sz4j)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#5wpp04i8ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.422 11.396 1.853 3.183",
    stroke: "url(#c2isdjholl)",
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#zknigwi2km)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.57 8.752 1.645 2.772",
    stroke: "url(#jr422zbtbn)",
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e8u1ubfh3o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.017 6.298 2.262 3.736",
    stroke: "url(#w7als8t1hp)",
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jhqhr7usqq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.252 3.665-.915-1.238a.351.351 0 0 1 .173-.542l1.02-.318c.225-.07.45.117.435.357L6.86 3.48c-.03.317-.42.441-.608.185z",
    fill: "#187EC9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#7ktlnvza0r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.482 4.883-1.395-.585a.332.332 0 0 1-.113-.54l.728-.773a.338.338 0 0 1 .548.083l.667 1.357c.128.277-.15.578-.435.458z",
    fill: "#1A78C3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dazaik9gzs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7 6.979-1.555.202a.347.347 0 0 1-.38-.427l.256-1.075a.354.354 0 0 1 .536-.21l1.297.871c.264.188.163.6-.155.639z",
    fill: "#1C75C1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#86mw52z57t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.231 21.952a5.146 5.146 0 0 0 6.9-2.49l.013.003c.716-1.47.583-2.706.474-3.73a12.513 12.513 0 0 1-.064-.712c-.035-.68-.03-1.834-.015-2.704l.002-.045.117-2.433a1.637 1.637 0 1 0-3.27-.158l-.007.144-2.135-4.044a1.586 1.586 0 0 0-2.937.347l-.2-.323a1.586 1.586 0 1 0-2.7 1.665l.065.102A1.566 1.566 0 0 0 9.88 9.938l.394.64a1.584 1.584 0 0 0-1.75 2.363l4.033 6.545c.833 1.314 1.896 2.092 2.674 2.466z",
    fill: "url(#d451l3a1uu)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.231 21.952a5.146 5.146 0 0 0 6.9-2.49l.013.003c.716-1.47.583-2.706.474-3.73a12.513 12.513 0 0 1-.064-.712c-.035-.68-.03-1.834-.015-2.704l.002-.045.117-2.433a1.637 1.637 0 1 0-3.27-.158l-.007.144-2.135-4.044a1.586 1.586 0 0 0-2.937.347l-.2-.323a1.586 1.586 0 1 0-2.7 1.665l.065.102A1.566 1.566 0 0 0 9.88 9.938l.394.64a1.584 1.584 0 0 0-1.75 2.363l4.033 6.545c.833 1.314 1.896 2.092 2.674 2.466z",
    fill: "url(#njaxh7c9yv)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#18pkjl0bew)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.01 18.26-3.26-5.527a.67.67 0 0 1 1.132-.716l1.843 2.724a.5.5 0 0 0 .836-.548L11.69 9.666a.65.65 0 1 1 1.104-.682l2.8 4.653a.47.47 0 0 0 .81-.477l-3.21-5.565a.717.717 0 1 1 1.24-.72l3.305 5.655a.416.416 0 0 0 .76-.093.415.415 0 0 0-.038-.316L16.3 8.174a.68.68 0 0 1 1.19-.663l2.501 4.417a6.47 6.47 0 0 1 .13-.865c.247-1.019.58-1.417.943-1.417.376 0 .819.16.698 1.34-.24 2.345-.044 3.97 0 4.276.043.304.714 3.57-2.382 4.944-2.477 1.1-4.68-.82-5.37-1.947h-.001z",
    fill: "url(#po17azv26x)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.22 11.28a1.584 1.584 0 1 0-2.696 1.662l4.073 6.609a1.584 1.584 0 0 0 2.697-1.662l-4.073-6.61z",
    fill: "url(#1q08djau4y)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 7.785a1.565 1.565 0 0 0-.51 2.152l.394.642c.38.1.724.34.947.701l3.665 5.947a1.565 1.565 0 0 0 1.722-2.337l-4.065-6.594a1.565 1.565 0 0 0-2.152-.511z",
    fill: "url(#3mox5wv4zz)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 7.785a1.565 1.565 0 0 0-.51 2.152l.394.642c.38.1.724.34.947.701l3.665 5.947a1.565 1.565 0 0 0 1.722-2.337l-4.065-6.594a1.565 1.565 0 0 0-2.152-.511z",
    fill: "url(#6k3dy9i6bA)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.929 5.291a1.586 1.586 0 0 0-.518 2.18l.063.103c.427.073.824.323 1.07.722l3.985 6.466a1.586 1.586 0 0 0 1.626-2.392L14.11 5.807a1.585 1.585 0 0 0-2.181-.516z",
    fill: "url(#cfp8pcs5qB)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.929 5.291a1.586 1.586 0 0 0-.518 2.18l.063.103c.427.073.824.323 1.07.722l3.985 6.466a1.586 1.586 0 0 0 1.626-2.392L14.11 5.807a1.585 1.585 0 0 0-2.181-.516z",
    fill: "url(#10shgtwujC)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m14.309 6.13 3.846 6.24a1.585 1.585 0 0 1-.078 1.777 1.586 1.586 0 0 0 2.767-1.547l-3.598-6.817a1.585 1.585 0 0 0-2.937.347z",
    fill: "url(#ceepc0213D)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m14.309 6.13 3.846 6.24a1.585 1.585 0 0 1-.078 1.777 1.586 1.586 0 0 0 2.767-1.547l-3.598-6.817a1.585 1.585 0 0 0-2.937.347z",
    fill: "url(#b1cs8l8l0E)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.445 13.742 19.38 9.83l.007-.146a1.638 1.638 0 1 1 3.27.158l-.117 2.434a1.638 1.638 0 0 1-1.096 1.467z",
    fill: "url(#n5t1qlpklF)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ijyanba09G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.307 12 2.579 3.854",
    stroke: "#FFDDC7",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vb637knadH)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.573 8.695 3.753 5.532",
    stroke: "#FFE0C7",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ky5ujdjtzI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.144 6.298 4.17 6.46",
    stroke: "#FFE3C8",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sloat0rsyJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.003 6.094 3.097 5.398",
    stroke: "#FFE4C9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eo76izzazK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.383 9.44c-.234 2.05-.128 4.755 0 6.526",
    stroke: "url(#jli3onwqrL)",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "vm5b2u7dcb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-93.888 16.006 4.498) scale(16.2049 11.2371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF9A84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d36sg3992c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-141.582 10.407 6.694) scale(7.35988 3.80044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0736C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0736C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ng29t901md",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(58.092 -7.602 12.827) scale(3.46175 1.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B87C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B87C69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "muvpp4p9te",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.06383 2.47406 -3.06091 .07897 7.195 7.754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB198",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rjyxqwqcuf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.24883 3.69447 -1.45083 .88312 8.633 9.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC8067",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "6u7v62dtng",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.08487 2.248 -2.23183 -.08426 8.83 5.325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6BFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6BFA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m15e99bkyh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.29893 4.93645 -1.93142 1.29073 10.76 7.931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8567",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "33xwknrbfi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.04 4.84 6.775) scale(3.34272 3.29047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDB49A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dufrd1sz4j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90.53 -1.869 8.367) scale(2.95692 3.22067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9F87",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d451l3a1uu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 11.1785 -9.20018 0 15.497 11.276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B0AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "njaxh7c9yv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(176.209 12.074 8.55) scale(4.55467 17.4863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "po17azv26x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(95.909 4.044 14.441) scale(14.8456 16.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "1q08djau4y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.54555 1.57467 -1.82055 .63074 9.358 10.232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B399",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "3mox5wv4zz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.02852 4.10265 -1.46016 1.07787 10.486 11.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E29F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29F7F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "6k3dy9i6bA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.84313 2.4798 -3.9679 1.34909 10.61 6.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B398",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cfp8pcs5qB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(48.528 -3.626 16.95) scale(5.98172 2.1303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A584",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "10shgtwujC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.02891 2.747 -4.40307 -.04634 13.008 4.683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACEB2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ceepc0213D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(49.833 -.929 18.93) scale(7.03819 2.46545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A580",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b1cs8l8l0E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.16438 2.13656 -3.16577 -.24357 16.16 4.422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED3B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n5t1qlpklF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.0744 -4.65603 2.63405 .0421 19.066 10.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C88C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A886",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r89dl3y68a",
    x: 4.153,
    y: 4.935,
    width: 12.141,
    height: 17.544,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.819608 0 0 0 0 0.6 0 0 0 0 0.552941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "5wpp04i8ck",
    x: 5.172,
    y: 10.145,
    width: 4.353,
    height: 5.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "zknigwi2km",
    x: 6.319,
    y: 7.502,
    width: 4.146,
    height: 5.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e8u1ubfh3o",
    x: 7.766,
    y: 5.048,
    width: 4.763,
    height: 6.236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "jhqhr7usqq",
    x: 5.118,
    y: 1.453,
    width: 2.097,
    height: 2.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.109804 0 0 0 0 0.580392 0 0 0 0 0.905882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70447"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0862745 0 0 0 0 0.317647 0 0 0 0 0.654902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_36744_70447",
    result: "effect2_innerShadow_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "7ktlnvza0r",
    x: 2.73,
    y: 2.88,
    width: 2.469,
    height: 2.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.568627 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70447"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0784314 0 0 0 0 0.341176 0 0 0 0 0.588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_36744_70447",
    result: "effect2_innerShadow_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dazaik9gzs",
    x: 1.605,
    y: 5.412,
    width: 2.651,
    height: 1.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.556863 0 0 0 0 0.87451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70447"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0941176 0 0 0 0 0.301961 0 0 0 0 0.603922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_36744_70447",
    result: "effect2_innerShadow_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "86mw52z57t",
    x: 8.289,
    y: 3.938,
    width: 15.416,
    height: 18.519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796078 0 0 0 0 0.552941 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_36744_70447"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.827451 0 0 0 0 0.588235 0 0 0 0 0.572549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_36744_70447",
    result: "effect2_innerShadow_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "18pkjl0bew",
    x: 8.659,
    y: 4.517,
    width: 15.194,
    height: 18.018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ijyanba09G",
    x: 8.432,
    y: 10.125,
    width: 6.329,
    height: 7.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vb637knadH",
    x: 9.698,
    y: 6.82,
    width: 7.503,
    height: 9.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ky5ujdjtzI",
    x: 11.269,
    y: 4.423,
    width: 7.921,
    height: 10.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sloat0rsyJ",
    x: 14.128,
    y: 4.219,
    width: 6.848,
    height: 9.149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eo76izzazK",
    x: 19.369,
    y: 7.565,
    width: 3.888,
    height: 10.276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_36744_70447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c2isdjholl",
    x1: 8.369,
    y1: 14.687,
    x2: 5.299,
    y2: 11.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A48D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jr422zbtbn",
    x1: 7.569,
    y1: 9.008,
    x2: 11.989,
    y2: 13.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2B49D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w7als8t1hp",
    x1: 9.607,
    y1: 5.791,
    x2: 14.35,
    y2: 10.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBB1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jli3onwqrL",
    x1: 21.314,
    y1: 9.44,
    x2: 21.314,
    y2: 15.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4C8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapping);
export default __webpack_public_path__ + "static/media/clapping.7dda608e606d44747931882e6b79416a.svg";
export { ForwardRef as ReactComponent };